import { useCallback } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { UsePanelCrearTipoEquipo } from "./UsePanelCrearTipoEquipo";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { TextField } from "@fluentui/react";

export interface IPanelCrearTipoEquipo extends IOpenPanel{

}

export const PanelCrearTipoEquipo=(props:IPanelCrearTipoEquipo)=>{
   const {request,setRequest,postInsertarTipoEquipo,loading,disableForm,reset,mensaje,status} = UsePanelCrearTipoEquipo(props)
   const onRenderFooter = useCallback(
      () => (
        <>
          <PanelFooter
            texto="Guardar"
            texto2={"Salir"}
            disableButton={disableForm}
            onClick={postInsertarTipoEquipo}
            onDismiss={() => {
               reset()
            }}
          />
        </>
      ),
      [disableForm,request]
    );
    return (
      <PanelDrawer isOpen={props.isOpen} onDismiss={reset} textHeader={"Agregar Tipo Equipo"} 
      status={status} mensaje={mensaje} loading={loading} onRenderFooter={onRenderFooter}>
       <TextField 
         type="text"
         label="Nombre de Tipo Equipo"
         placeholder="Ingrese Nombre de Tipo de Equipo"
         autoComplete="off"
         value={request.nombre}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,nombre:newValue})}
         }}
         />
      <TextField 
         type="text"
         label="Codigo de Tipo Equipo"
         placeholder="Ingrese Codigo de Tipo de Equipo"
         autoComplete="off"
         value={request.codigo}
         onChange={(event,newValue)=>{
            if(newValue!=null){
            setRequest({...request,codigo:newValue})}
         }}
         />

      </PanelDrawer>
      
         
         )

}